import { createContext, useContext, useMemo, useState, type ReactNode } from "react";

/**
 * Shared sidebar collapse state (codonix design) — read by the AppShell grid
 * (animates the sidebar column to 0px), the Sidebar's collapse handle, and the
 * floating re-opener, so all three stay in sync.
 */
interface SidebarToggle {
  collapsed: boolean;
  setCollapsed: (value: boolean) => void;
  toggle: () => void;
}

const SidebarToggleContext = createContext<SidebarToggle | null>(null);

export function SidebarToggleProvider({ children }: { children: ReactNode }) {
  const [collapsed, setCollapsed] = useState(false);
  const value = useMemo<SidebarToggle>(
    () => ({ collapsed, setCollapsed, toggle: () => setCollapsed((v) => !v) }),
    [collapsed]
  );
  return <SidebarToggleContext.Provider value={value}>{children}</SidebarToggleContext.Provider>;
}

export function useSidebarToggle(): SidebarToggle {
  const ctx = useContext(SidebarToggleContext);
  if (!ctx) throw new Error("useSidebarToggle must be used within a SidebarToggleProvider");
  return ctx;
}
